import { Badge } from '../ui/badge';
import { CheckCircle, AlertTriangle, AlertCircle, Clock } from 'lucide-react';

export const ComplianceBadge = ({ status, className = '' }) => {
  const statusConfig = {
    compliant: {
      className: 'bg-green-100 text-green-800 border-green-200',
      icon: CheckCircle,
      label: 'Compliant'
    },
    at_risk: {
      className: 'bg-amber-100 text-amber-800 border-amber-200',
      icon: AlertTriangle,
      label: 'At Risk'
    },
    non_compliant: {
      className: 'bg-red-100 text-red-800 border-red-200',
      icon: AlertCircle,
      label: 'Non-Compliant'
    },
    pending: {
      className: 'bg-blue-100 text-blue-800 border-blue-200',
      icon: Clock,
      label: 'Pending'
    }
  };

  const config = statusConfig[status?.toLowerCase()] || statusConfig.pending;
  const Icon = config.icon;

  return (
    <Badge 
      className={`flex items-center gap-1.5 ${config.className} ${className}`}
      data-testid={`compliance-badge-${status?.toLowerCase()}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {config.label}
    </Badge>
  );
};